/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ state: NonNullable<unknown>, confirmed: NonNullable<unknown> }} Signuphinton2Inputs */

const en_signuphinton2 = /** @type {(inputs: Signuphinton2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.state} · ${i?.confirmed} signed up`)
};

const de_signuphinton2 = /** @type {(inputs: Signuphinton2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.state} · ${i?.confirmed} angemeldet`)
};

/**
* | output |
* | --- |
* | "{state} · {confirmed} signed up" |
*
* @param {Signuphinton2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signuphinton2 = /** @type {((inputs: Signuphinton2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signuphinton2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signuphinton2(inputs)
	return de_signuphinton2(inputs)
});
export { signuphinton2 as "signupHintOn" }